/**
 * Formateadores compartidos. Fuente ÚNICA — reemplazan las copias inline que
 * hoy se repiten en cada modal de drill-down (ver ANALISIS-CRITICO H10).
 */

const MXN = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  maximumFractionDigits: 2,
});

/** Moneda MXN. Tolera valores no finitos (los trata como 0). */
export function money(n: number): string {
  return MXN.format(Number.isFinite(n) ? n : 0);
}

/** Entero con separador de miles (es-MX). */
export function num(n: number): string {
  return Math.round(Number.isFinite(n) ? n : 0).toLocaleString('es-MX');
}

/** Fecha + hora corta. Devuelve el original si no parsea. */
export function fmtDate(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleString('es-MX', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
}

/** Solo fecha (sin hora). Devuelve el original si no parsea. */
export function fmtDay(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' });
}
